import { Button } from '@workboard/wobo-ui';
import React from 'react';
import styled from 'styled-components';
import * as testIds from './testIds';

const FooterEl = styled.div`
  border-top: 1px solid #dddddd;

  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;

  ${Button} {
    margin-right: 8px;
    text-transform: capitalize;
    display: flex;

    &:last-child {
      margin: 0;
    }
  }
`;

const ChildContainer = styled.div`
  flex-grow: 1;
  position: relative;
  right: 16px;
`;

export type Props = {
  children?: React.ReactChild;
  className?: string;
  id?: string;
  submitLabel?: string;
  dismissLabel?: string;
  removeSubmit?: boolean;
  removeDismiss?: boolean;
  isDanger?: boolean;
  divider?: boolean;
  onDismiss: () => void;
  onSubmit: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

export const CopyAiDialogActions = ({
  id,
  submitLabel,
  dismissLabel,
  removeSubmit,
  removeDismiss,
  isDanger,
  onDismiss,
  onSubmit,
  children,
}: Props) => (
  <FooterEl id={id} data-testid="wbui-footer-action">
    {children ? <ChildContainer>{children}</ChildContainer> : null}
    {!removeDismiss && (
      <Button
        variant={removeSubmit ? 'secondary' : 'ghost'}
        data-testid={testIds.cancelBtn}
        onClick={onDismiss}
      >
        {dismissLabel}
      </Button>
    )}
    <Button
      data-testid={testIds.submitBtn}
      variant="primary"
      onClick={onSubmit}
      kind={isDanger ? 'danger' : 'normal'}
      isDisabled={removeSubmit}
    >
      {submitLabel}
    </Button>
  </FooterEl>
);
